import gql from "graphql-tag";

export const dealerIncentiveQuery = gql`
  query dealerIncentive($id: ID!, $productsPage: Int, $productsPerPage: Int) {
    dealerIncentive(id: $id) {
      id
      name
      description
      startsAt
      endsAt
      measurementUnit
      targetValue
      reward
      color
      status
      completedEarlyAt
      createdAt
      creator {
        firstName
        lastName
        secondName
      }
      type {
        id
        name
      }
      banner {
        id
        name
        link
      }
      icon {
        id
        name
        link
      }
      products(page: $productsPage, first: $productsPerPage) {
        data {
          id
          productCode
          name
          category {
            description
          }
        }
        paginatorInfo {
          currentPage
          lastPage
          perPage
          total
        }
      }
    }
  }
`;
